<template>
  <div v-if="show" class="modal-overlay" @click.self="closeModal">
    <div class="order-modal animate-pop">

      <!-- HEADER -->
      <div class="order-modal-header">
        <h3>Yangi buyurtma</h3>
        <div class="header-info">
          <span v-if="newOrder.kontragent_id" class="sale-type-badge" :class="clientSaleType">
            {{ clientSaleType === 'optom' ? 'OPTOM' : 'CHAKANA' }}
          </span>
          <button class="btn-close-modal" @click="closeModal">&times;</button>
        </div>
      </div>

      <!-- Mobil uchun tab tugmalari (faqat kichik ekranda ko'rinadi) -->
      <div class="mobile-panel-tabs">
        <button type="button" :class="['mpt-btn', { active: mobilePanel === 'browse' }]" @click="mobilePanel = 'browse'">
          Tanlash
        </button>
        <button type="button" :class="['mpt-btn', { active: mobilePanel === 'cart' }]" @click="mobilePanel = 'cart'">
          Savat
          <span v-if="newOrder.products.length + newOrder.services.length" class="mpt-badge">
            {{ newOrder.products.length + newOrder.services.length }}
          </span>
        </button>
      </div>

      <!-- BODY — 2 USTUN -->
      <div class="order-modal-body">

        <!-- ==== CHAP PANEL: Tanlash ==== -->
        <div class="panel-left" :class="{ 'mobile-hidden': mobilePanel !== 'browse' }">

          <!-- Mijoz + ma'lumotlar -->
          <div class="panel-section">
            <div class="row-2">
              <div class="form-group">
                <label>Mijoz *</label>
                <div class="client-select-row">
                  <div class="client-picker">
                    <input
                      v-model="clientKeyword"
                      type="text"
                      class="form-input"
                      placeholder="Mijozni ism yoki telefon orqali qidiring..."
                      autocomplete="off"
                      @focus="showClientResults = true"
                      @input="onClientSearch"
                    >
                    <div v-if="showClientResults" class="client-results">
                      <button
                        v-for="client in filteredClients"
                        :key="client.id"
                        type="button"
                        class="client-result"
                        @mousedown.prevent="selectClient(client)"
                      >
                        <span>{{ client.name }}</span>
                        <small>{{ client.phone_number }}</small>
                      </button>
                      <div v-if="filteredClients.length === 0" class="client-no-results">
                        Mijoz topilmadi
                      </div>
                    </div>
                  </div>
                  <button type="button" class="btn-add-client" @click="openClientModal" title="Yangi mijoz qo'shish">+</button>
                </div>
              </div>
              <div class="form-group">
                <label>Telefon</label>
                <input v-model="newOrder.phone_number" type="text" class="form-input" placeholder="+998...">
              </div>
            </div>
            <div class="row-2">
              <div class="form-group">
                <label>Manzil</label>
                <input v-model="newOrder.address" type="text" class="form-input" placeholder="Manzil...">
              </div>
              <div class="form-group">
                <label>Izoh</label>
                <input v-model="newOrder.comment" type="text" class="form-input" placeholder="Izoh...">
              </div>
            </div>
          </div>

          <!-- Navigatsiya bar: Breadcrumb + Qidiruv + Tablar + Paket turi -->
          <div class="nav-bar">
            <div class="nav-inner">
              <nav class="breadcrumb-nav">
                <a href="#" @click.prevent="resetBrowse">Brendlar</a>
                <template v-if="selectedBrand">
                  <span class="bc-sep">/</span>
                  <a href="#" @click.prevent="backToBrand">{{ selectedBrand.name }}</a>
                </template>
                <template v-if="selectedModel">
                  <span class="bc-sep">/</span><span class="bc-current">{{ selectedModel.name }}</span>
                </template>
              </nav>

              <input
                type="text"
                v-model="productKeyword"
                @input="onBrowseSearch"
                class="nav-search"
                placeholder="Qidirish..."
              >

              <div class="nav-tabs">
                <button :class="['nav-tab-btn', browseTab === 'service' ? 'active' : '']" @click="browseTab = 'service'">Xizmatlar</button>
                <button :class="['nav-tab-btn', browseTab === 'product' ? 'active' : '']" @click="switchToProductTab">Mahsulotlar</button>
              </div>
            </div>

            <!-- Paket turi chiplari (faqat xizmatlar tabida) -->
            <div v-if="browseTab === 'service' && packageTypes.length > 0" class="brand-chips type-chips">
              <button
                v-if="typeFilterActive"
                class="brand-chip back-chip"
                @click="resetBrowse"
                title="Brendlar ko'rinishiga qaytish"
              >
                <b-icon icon="arrow-left"></b-icon> Brendlar
              </button>
              <button
                :class="['brand-chip', { active: typeFilterActive && selectedTypeId === null }]"
                @click="selectTypeFilter(null)"
              >
                Barchasi <span class="chip-count">{{ packageList.length }}</span>
              </button>
              <button
                v-for="pt in packageTypes"
                :key="pt.id"
                :class="['brand-chip', { active: selectedTypeId === pt.id }]"
                @click="selectTypeFilter(pt.id)"
              >
                {{ pt.name }} <span class="chip-count">{{ countByType(pt.id) }}</span>
              </button>
            </div>
          </div>

          <!-- Browse content -->
          <div class="browse-content">

            <!-- 1. Brendlar gridi (paket turi filter faol emas, brand tanlanmagan) -->
            <div v-if="!typeFilterActive && !selectedBrand && !showAllItems && !(productKeyword || '').trim()" class="browse-grid brand-grid">
              <div class="browse-card all-card" @click="showAllBrowse">
                <span class="all-icon">&#9776;</span>
                <span class="bc-name" style="text-align:center">Barchasi</span>
              </div>
              <div v-for="b in brandList" :key="b.id" class="browse-card brand-card" @click="selectBrowseBrand(b)">
                <img v-if="b.image" :src="imageUrl + b.image" alt="" class="brand-img">
                <span class="bc-name" style="text-align:center">{{ b.name }}</span>
              </div>
            </div>

            <!-- 2. Modellar gridi -->
            <div v-else-if="!typeFilterActive && selectedBrand && !selectedModel && !showAllItems" class="browse-grid brand-grid">
              <div class="browse-card all-card" @click="showAllModelsOfBrand">
                <span class="all-icon">&#9776;</span>
                <span class="bc-name" style="text-align:center">Barcha modellar</span>
              </div>
              <div v-for="m in modelList" :key="m.id" class="browse-card brand-card" @click="selectBrowseModel(m)">
                <img v-if="m.image" :src="imageUrl + m.image" alt="" class="brand-img">
                <span class="bc-name" style="text-align:center">{{ m.name }}</span>
              </div>
              <div v-if="modelList.length === 0" class="browse-empty">
                Modellar topilmadi
              </div>
            </div>

            <!-- 3. Xizmatlar yoki Mahsulotlar -->
            <template v-else>

              <!-- Xizmat paketlari -->
              <div v-if="browseTab === 'service'">
                <div class="browse-grid">
                <div
                  v-for="pkg in displayedPackages" :key="pkg.id"
                  class="browse-card pkg-card"
                  :class="{ 'browse-card-added': getServiceCount(pkg.id) > 0 }"
                  @click="addOrderService(pkg)"
                >
                  <div class="bc-name">{{ pkg.name }}</div>
                  <div v-if="pkg.model" class="bc-meta">
                    <span class="bc-balance">{{ pkg.model.name }}</span>
                  </div>
                  <div class="bc-prices">
                    <span class="bc-price active">
                      {{ clientSaleType === 'optom' ? 'Optom' : 'Chakana' }}: {{ formatMoney(packageDisplayPrice(pkg)) }}
                    </span>
                  </div>
                  <div v-if="pkg.items && pkg.items.length > 0" class="bc-materials">
                    {{ pkg.items.length }} material
                  </div>
                  <div v-if="getServiceCount(pkg.id) > 0" class="qty-controls" @click.stop>
                    <button class="qty-btn-small minus" @click="decrementServiceById(pkg.id)">−</button>
                    <span class="qty-num">{{ getServiceCount(pkg.id) }}</span>
                    <button class="qty-btn-small plus" @click="addOrderService(pkg)">+</button>
                  </div>
                </div>
                <div v-if="displayedPackages.length === 0" class="browse-empty">Xizmat paketlari topilmadi</div>
                </div>
              </div>

              <!-- Mahsulotlar -->
              <div v-else>
              <!-- Papka yo'li (qidiruvda barcha papkalardan qidiriladi, shuning uchun yashiriladi) -->
              <div v-if="!(productKeyword || '').trim()" class="folder-path">
                <a v-if="showAllItems || selectedBrand" href="#" @click.prevent="resetBrowse">
                  <b-icon icon="arrow-left"></b-icon> Brendlar
                </a>
                <span v-if="showAllItems || selectedBrand" class="fp-sep">|</span>
                <a v-if="folderPath.length" href="#" @click.prevent="goToFolder(-1)">
                  <b-icon icon="folder2-open"></b-icon> Barcha mahsulotlar
                </a>
                <span v-else class="fp-active"><b-icon icon="folder2-open"></b-icon> Barcha mahsulotlar</span>
                <template v-for="(f, i) in folderPath">
                  <span :key="'s' + f.id" class="fp-sep">/</span>
                  <a v-if="i < folderPath.length - 1" :key="f.id" href="#" @click.prevent="goToFolder(i)">{{ f.name }}</a>
                  <span v-else :key="f.id" class="fp-active">{{ f.name }}</span>
                </template>
              </div>
              <div class="browse-grid">
                <div
                  v-for="p in searchedProducts.filter(x => isFolder(x))" :key="'f' + p.id"
                  class="browse-card folder-card"
                  title="Ochish uchun 2 marta bosing"
                  @dblclick="openFolder(p)"
                >
                  <b-icon icon="folder-fill" class="folder-icon"></b-icon>
                  <div class="bc-name">{{ p.extra_name || p.name }}</div>
                  <div class="bc-meta">2 marta bosing</div>
                </div>
                <div
                  v-for="p in searchedProducts.filter(x => !isFolder(x))" :key="p.id"
                  class="browse-card"
                  :class="{ 'browse-card-added': getProductCount(p.id) > 0 }"
                  @click="addOrderProduct(p)"
                >
                  <div class="bc-name">{{ p.extra_name || p.name }}</div>
                  <div class="bc-meta">
                    <span class="bc-balance">Qoldiq: {{ p.balance || 0 }}</span>
                  </div>
                  <div class="bc-prices">
                    <span class="bc-price active">
                      {{ clientSaleType === 'optom' ? 'Optom' : 'Chakana' }}: {{ formatMoney(getProductPrice(p)) }}
                    </span>
                  </div>
                  <div v-if="getProductCount(p.id) > 0" class="qty-controls" @click.stop>
                    <button class="qty-btn-small minus" @click="decrementProductById(p.id)">−</button>
                    <span class="qty-num">{{ getProductCount(p.id) }}</span>
                    <button class="qty-btn-small plus" @click="addOrderProduct(p)">+</button>
                  </div>
                </div>
                <div v-if="searchedProducts.length === 0" class="browse-empty">Mahsulot topilmadi</div>
              </div>
              </div>

            </template>
          </div>
        </div>

        <!-- ==== O'NG PANEL: Savatcha ==== -->
        <div class="panel-right" :class="{ 'mobile-hidden': mobilePanel !== 'cart' }">
          <div class="cart-title">
            Savatcha
            <span class="cart-count">{{ newOrder.products.length + newOrder.services.length }}</span>
          </div>

          <div v-if="newOrder.products.length === 0 && newOrder.services.length === 0" class="cart-empty">
            Chapdan mahsulot yoki xizmat tanlang
          </div>

          <div class="cart-list">
            <div v-for="(p, idx) in newOrder.products" :key="'p-' + idx" class="cart-item">
              <div class="ci-top">
                <span class="ci-name">{{ p.name }}</span>
                <button class="ci-remove" @click="newOrder.products.splice(idx, 1)">&times;</button>
              </div>
              <div class="ci-bottom">
                <div class="ci-qty">
                  <button class="qty-btn" @click="p.count > 1 ? p.count-- : null">-</button>
                  <span class="qty-val">{{ p.count }}</span>
                  <button class="qty-btn" @click="p.count++">+</button>
                </div>
                <span class="ci-price">{{ formatMoney(p.price * p.count) }}</span>
              </div>
            </div>

            <div v-for="(s, idx) in newOrder.services" :key="'s-' + idx" class="cart-item cart-service">
              <div class="ci-top">
                <span class="ci-name">{{ s.name }}</span>
                <button class="ci-remove" @click="removeOrderService(idx)">&times;</button>
              </div>
              <div class="ci-bottom">
                <div class="ci-qty">
                  <button class="qty-btn" @click="decrementService(idx)">-</button>
                  <span class="qty-val">{{ s.count }}</span>
                  <button class="qty-btn" @click="s.count++">+</button>
                </div>
                <span class="ci-price">{{ formatMoney((s.price + s.product_summa) * s.count) }}</span>
              </div>
              <div
                v-for="(sp, spIdx) in newOrder.serviceProducts.filter(x => x.from_service === s.package_id)"
                :key="'sp-' + spIdx"
                class="ci-material"
              >
                <span>↳ {{ sp.name }} ({{ sp.count }}<span v-if="s.count > 1"> × {{ s.count }}</span>)</span>
                <span>{{ formatMoney(sp.price * sp.count * s.count) }}</span>
              </div>
            </div>
          </div>

          <div class="cart-footer">
            <div class="cart-total">
              <span>Jami:</span>
              <span class="total-value">{{ formatMoney(newOrderTotal) }} so'm</span>
            </div>
            <button class="submit-btn" @click="submitNewOrder" :disabled="creatingOrder">
              {{ creatingOrder ? 'Saqlanmoqda...' : 'Buyurtma yaratish' }}
            </button>
          </div>
        </div>

      </div>

      <!-- YANGI MIJOZ MODALI -->
      <div v-if="showClientModal" class="modal-overlay client-overlay" @click.self="showClientModal = false">
        <div class="client-modal animate-pop">
          <div class="order-modal-header">
            <h3>Yangi Mijoz Qo'shish</h3>
            <button class="btn-close-modal" @click="showClientModal = false">&times;</button>
          </div>

          <div class="client-modal-body">
            <div class="client-cols">

              <!-- Chap: Umumiy ma'lumotlar -->
              <div class="client-col client-col-divider">
                <div class="client-section-header">
                  <b-icon icon="person-lines-fill"></b-icon>
                  <span>Umumiy ma'lumotlar</span>
                </div>

                <div class="form-unit">
                  <label>F.I.O / Tashkilot nomi <span class="required-star">*</span></label>
                  <input v-model="newClient.name" type="text" placeholder="Kiriting..." @keyup.enter="saveNewClient">
                </div>

                <div class="cu-row">
                  <div class="form-unit">
                    <label>Telefon</label>
                    <input v-model="newClient.phone_number" type="text" placeholder="+998" @keyup.enter="saveNewClient">
                  </div>
                  <div class="form-unit">
                    <label>Manzil</label>
                    <input v-model="newClient.address" type="text" placeholder="Shahar, ko'cha...">
                  </div>
                </div>

                <div class="form-unit">
                  <label>Izoh</label>
                  <textarea v-model="newClient.comment" rows="4" placeholder="Qo'shimcha ma'lumotlar..."></textarea>
                </div>
              </div>

              <!-- O'ng: Moliyaviy ma'lumotlar -->
              <div class="client-col">
                <div class="client-section-header">
                  <b-icon icon="wallet2"></b-icon>
                  <span>Moliyaviy ma'lumotlar</span>
                </div>

                <div class="form-unit">
                  <label>Mijoz turi <span class="required-star">*</span></label>
                  <div class="client-type-toggle">
                    <button type="button" :class="['client-type-btn', { active: Number(newClient.type) === 1 }]" @click="newClient.type = 1">
                      <b-icon icon="person-fill" class="mr-1"></b-icon> Oddiy mijoz
                    </button>
                    <button type="button" :class="['client-type-btn', { active: Number(newClient.type) === 2 }]" @click="newClient.type = 2">
                      <b-icon icon="tools" class="mr-1"></b-icon> Usta mijoz
                    </button>
                    <button type="button" :class="['client-type-btn', { active: Number(newClient.type) === 3 }]" @click="newClient.type = 3">
                      <b-icon icon="gear-fill" class="mr-1"></b-icon> Zapchas mijoz
                    </button>
                  </div>
                </div>

                <div class="form-unit">
                  <label>Sotuv turi</label>
                  <div class="sale-type-toggle">
                    <button type="button" :class="['sale-type-btn', { active: newClient.sale_type === 'chakana' }]" @click="newClient.sale_type = 'chakana'">
                      Chakana
                    </button>
                    <button type="button" :class="['sale-type-btn', { active: newClient.sale_type === 'optom' }]" @click="newClient.sale_type = 'optom'">
                      Optom
                    </button>
                  </div>
                </div>

                <div class="cu-row">
                  <div class="form-unit">
                    <label>INN</label>
                    <input v-model="newClient.inn" type="text" placeholder="000 000 000">
                  </div>
                  <div class="form-unit">
                    <label>MFO</label>
                    <input v-model="newClient.mfo_id" type="text" placeholder="00000">
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="client-modal-footer">
            <button class="client-cancel-btn" @click="showClientModal = false">Bekor qilish</button>
            <button class="submit-btn" @click="saveNewClient" :disabled="savingClient">
              {{ savingClient ? 'Saqlanmoqda...' : 'Saqlash' }}
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ZakazForm',
  props: {
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      // Mobil ekranda ikki panel (Tanlash/Savat) navbat bilan ko'rsatiladi
      mobilePanel: 'browse',
      creatingOrder: false,
      showClientModal: false,
      savingClient: false,
      newClient: {
        name: '', phone_number: '+998', address: '', comment: '',
        inn: '', mfo_id: 0, type: 1, sale_type: 'chakana',
      },
      clientList: [],
      clientKeyword: '',
      showClientResults: false,
      brandList: [],
      modelList: [],
      packageList: [],
      packageTypes: [],
      selectedTypeId: null,
      typeFilterActive: false,
      searchedProducts: [],
      // Mahsulot papkalari bo'ylab navigatsiya: 0 = ildiz, folderPath = [{id, name}, ...]
      currentFolderId: 0,
      folderPath: [],
      productKeyword: '',
      browseTab: 'service',
      selectedBrand: null,
      selectedModel: null,
      selectedBrandId: null,
      selectedModelId: null,
      showAllItems: false,
      imageUrl: process.env.VUE_APP_BASE_URL + 'api/v1/uploads/',
      newOrder: {
        kontragent_id: null,
        phone_number: '',
        address: '',
        comment: '',
        products: [],
        services: [],
        serviceProducts: [],
      },
    };
  },
  computed: {
    clientSaleType() {
      if (!this.newOrder.kontragent_id) return 'chakana';
      const client = this.clientList.find(c => c.id === this.newOrder.kontragent_id);
      return client?.sale_type || 'chakana';
    },
    filteredClients() {
      const keyword = this.clientKeyword.trim().toLowerCase();
      if (!keyword) return this.clientList;
      return this.clientList.filter(client => (
        `${client.name || ''} ${client.phone_number || ''}`.toLowerCase().includes(keyword)
      ));
    },
    newOrderTotal() {
      const prodTotal = this.newOrder.products.reduce((s, p) => s + p.price * p.count, 0);
      const srvTotal = this.newOrder.services.reduce((s, srv) => {
        const cnt = srv.count || 1;
        return s + ((srv.price || 0) + (srv.product_summa || 0)) * cnt;
      }, 0);
      return prodTotal + srvTotal;
    },
    filteredByBrand() {
      let list = this.packageList;
      if (this.selectedBrandId !== null) {
        list = list.filter(p => p.model && p.model.brand_id === this.selectedBrandId);
      }
      if (this.selectedModelId !== null) {
        list = list.filter(p => p.model_id === this.selectedModelId);
      }
      if (this.productKeyword) {
        const kw = this.productKeyword.toLowerCase();
        list = list.filter(p => (p.name || '').toLowerCase().includes(kw));
      }
      return list;
    },
    filteredPackages() {
      return this.filteredByBrand;
    },
    displayedPackages() {
      if (this.selectedTypeId !== null) {
        // Paket turi tanlanganda brand/modeldan qat'iy nazar barcha mos paketlar
        let list = this.packageList.filter(p => p.package_type_id === this.selectedTypeId);
        if (this.productKeyword) {
          const kw = this.productKeyword.toLowerCase();
          list = list.filter(p => (p.name || '').toLowerCase().includes(kw));
        }
        return list;
      }
      return this.filteredByBrand;
    },
  },
  watch: {
    async show(val) {
      if (val) {
        await this.initForm();
      }
    },
  },
  methods: {
    async initForm() {
      this.newOrder = {
        kontragent_id: null, phone_number: '', address: '', comment: '',
        products: [], services: [], serviceProducts: [],
      };
      this.clientKeyword = '';
      this.showClientResults = false;
      this.browseTab = 'service';
      this.productKeyword = '';
      this.searchedProducts = [];
      this.currentFolderId = 0;
      this.folderPath = [];
      this.selectedBrand = null;
      this.selectedModel = null;
      this.selectedBrandId = null;
      this.selectedModelId = null;
      this.showAllItems = false;
      this.typeFilterActive = false;
      this.selectedTypeId = null;
      this.modelList = [];
      if (this.clientList.length === 0) {
        try {
          const res = await axios.get('api/v1/kontragent/');
          this.clientList = res.data || [];
        } catch (e) { this.clientList = []; }
      }
      if (this.brandList.length === 0) {
        try {
          const res = await axios.get('api/v1/brand/');
          this.brandList = res.data || [];
        } catch (e) { this.brandList = []; }
      }
      if (this.packageTypes.length === 0) {
        try {
          const res = await axios.get('api/v1/package_types');
          this.packageTypes = res.data || [];
        } catch (e) { this.packageTypes = []; }
      }
      this.typeFilterActive = false;
      // Paketlar va mahsulotlar darhol yuklansin
      this.fetchPackages();
      this.fetchModelProducts();
    },
    countByType(typeId) {
      let list = this.packageList.filter(p => p.package_type_id === typeId);
      if (this.productKeyword) {
        const kw = this.productKeyword.toLowerCase();
        list = list.filter(p => (p.name || '').toLowerCase().includes(kw));
      }
      return list.length;
    },
    selectTypeFilter(typeId) {
      // Paket turi tugmasi (Barchasi yoki aniq tur) — paketlar ro'yxatini ochadi
      this.selectedTypeId = typeId;
      this.typeFilterActive = true;
      // Brand/model tanlovini tozalash
      this.selectedBrand = null;
      this.selectedModel = null;
      this.selectedBrandId = null;
      this.selectedModelId = null;
      this.showAllItems = false;
    },
    resetBrowse() {
      this.selectedBrand = null;
      this.selectedModel = null;
      this.selectedBrandId = null;
      this.selectedModelId = null;
      this.showAllItems = false;
      this.typeFilterActive = false;
      this.selectedTypeId = null;
      this.modelList = [];
      this.searchedProducts = [];
      this.currentFolderId = 0;
      this.folderPath = [];
    },
    async selectBrowseBrand(brand) {
      this.typeFilterActive = false;
      this.selectedTypeId = null;
      this.selectedBrand = brand;
      this.selectedBrandId = brand.id;
      this.selectedModel = null;
      this.selectedModelId = null;
      this.showAllItems = false;
      this.modelList = [];
      try {
        const res = await axios.get(`api/v1/model/?brand_id=${brand.id}`);
        this.modelList = res.data || [];
      } catch (e) { this.modelList = []; }
    },
    async selectBrowseModel(model) {
      this.selectedModel = model;
      this.selectedModelId = model.id;
      this.showAllItems = false;
      await this.fetchModelProducts();
    },
    async showAllBrowse() {
      this.showAllItems = true;
      this.typeFilterActive = false;
      this.selectedTypeId = null;
      this.selectedBrand = null;
      this.selectedModel = null;
      this.selectedBrandId = null;
      this.selectedModelId = null;
      await this.fetchModelProducts();
    },
    async showAllModelsOfBrand() {
      this.showAllItems = true;
      this.selectedModel = null;
      this.selectedModelId = null;
      await this.fetchModelProducts();
    },
    backToBrand() {
      this.selectedModel = null;
      this.selectedModelId = null;
      this.showAllItems = false;
      this.searchedProducts = [];
    },
    closeModal() {
      this.$emit('close');
    },
    formatMoney(v) {
      if (!v) return '0';
      return Number(v).toLocaleString('ru-RU').replace(/ /g, ' ');
    },
    onClientChange() {
      const client = this.clientList.find(c => c.id === this.newOrder.kontragent_id);
      if (client) {
        this.newOrder.phone_number = client.phone_number || '';
        this.updateOrderPrices();
      }
    },
    onClientSearch() {
      this.newOrder.kontragent_id = null;
      this.showClientResults = true;
    },
    selectClient(client) {
      this.newOrder.kontragent_id = client.id;
      this.clientKeyword = `${client.name || ''} (${client.phone_number || ''})`;
      this.showClientResults = false;
      this.onClientChange();
    },
    openClientModal() {
      this.newClient = {
        name: '', phone_number: '+998', address: '', comment: '',
        inn: '', mfo_id: 0, type: 1, sale_type: 'chakana',
      };
      this.showClientModal = true;
    },
    async saveNewClient() {
      if (!this.newClient.name || this.newClient.name.trim().length < 3) {
        return alert("F.I.O kamida 3 ta belgi bo'lishi kerak!");
      }
      if (!this.newClient.phone_number || this.newClient.phone_number.trim().length < 5) {
        return alert('Telefon raqamini kiriting!');
      }
      this.savingClient = true;
      try {
        const sklad_id = Number(localStorage.getItem('sklad_id')) || 1;
        const res = await axios.post('api/v1/kontragent/', {
          name: this.newClient.name.trim(),
          phone_number: this.newClient.phone_number.trim(),
          address: this.newClient.address || '',
          comment: this.newClient.comment || ' ',
          inn: this.newClient.inn || '',
          mfo_id: this.newClient.mfo_id || 0,
          type: Number(this.newClient.type) || 1,
          sklad_id,
          sale_type: this.newClient.sale_type || 'chakana',
          password: '123456',
        });
        const created = res.data?.data || res.data;
        // Ro'yxatga qo'shib, darhol tanlaymiz
        this.clientList.push(created);
        this.newOrder.kontragent_id = created.id;
        this.clientKeyword = `${created.name || ''} (${created.phone_number || ''})`;
        this.onClientChange();
        this.showClientModal = false;
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || 'Mijozni saqlashda xato'));
      } finally {
        this.savingClient = false;
      }
    },
    updateOrderPrices() {
      const type = this.clientSaleType;
      for (const p of this.newOrder.products) {
        if (p.price_chakana !== undefined) {
          p.price = type === 'optom' ? Number(p.price_optom || 0) : Number(p.price_chakana || 0);
        }
      }
      for (const sp of this.newOrder.serviceProducts) {
        sp.price = type === 'optom' ? Number(sp.price_optom || 0) : Number(sp.price_chakana || 0);
      }
      for (const srv of this.newOrder.services) {
        const srvProducts = this.newOrder.serviceProducts.filter(p => p.from_service === srv.package_id);
        srv.product_summa = srvProducts.reduce((s, p) => s + p.price * p.count, 0);
        const labor = type === 'optom' ? srv.labor_price_optom : srv.labor_price_chakana;
        const redo = type === 'optom' ? srv.redo_price_optom : srv.redo_price_chakana;
        srv.price = labor + redo;
      }
    },
    getProductPrice(p) {
      const pr = p.price_register;
      if (!pr) return 0;
      return this.clientSaleType === 'optom' ? Number(pr.optom_price || 0) : Number(pr.chakana_price || 0);
    },
    packageDisplayPrice(pkg) {
      const type = this.clientSaleType;
      const labor = type === 'optom' ? Number(pkg.labor_price_optom || 0) : Number(pkg.labor_price_chakana || 0);
      const redo = type === 'optom' ? Number(pkg.redo_price_optom || 0) : Number(pkg.redo_price_chakana || 0);
      const itemsSum = (pkg.items || []).reduce((s, i) => {
        const ip = type === 'optom' ? Number(i.price_optom || 0) : Number(i.price_chakana || 0);
        return s + ip * (i.quantity || 1);
      }, 0);
      return labor + redo + itemsSum;
    },
    addOrderProduct(p) {
      const existing = this.newOrder.products.find(x => x.product_id === p.id && !x.from_service);
      if (existing) {
        existing.count++;
        return;
      }
      const pr = p.price_register;
      this.newOrder.products.push({
        product_id: p.id,
        name: p.extra_name || p.name,
        count: 1,
        price: this.getProductPrice(p),
        price_chakana: pr ? Number(pr.chakana_price || 0) : 0,
        price_optom: pr ? Number(pr.optom_price || 0) : 0,
        shtrix_kod: p.shtrix_kod || '',
      });
    },
    async switchToProductTab() {
      this.browseTab = 'product';
      if (this.searchedProducts.length === 0) {
        await this.fetchModelProducts();
      }
    },
    async onBrowseSearch() {
      if (this.browseTab === 'product') {
        await this.fetchModelProducts();
      }
    },
    isFolder(item) {
      return Number(item.is_folder) === 1;
    },
    openFolder(folder) {
      this.folderPath.push({ id: folder.id, name: folder.extra_name || folder.name });
      this.currentFolderId = folder.id;
      this.fetchModelProducts();
    },
    // index = -1 — ildizga, aks holda folderPath[index] papkasiga qaytish
    goToFolder(index) {
      this.folderPath = this.folderPath.slice(0, index + 1);
      this.currentFolderId = index >= 0 ? this.folderPath[index].id : 0;
      this.fetchModelProducts();
    },
    async fetchModelProducts() {
      try {
        const sklad_id = localStorage.getItem('sklad_id');
        const res = await axios.post(`api/v1/product/all-price-balance/${this.currentFolderId}`, {
          sklad_id,
          keyword: this.productKeyword || '',
          model_id: this.selectedModelId || 0,
          brand_id: this.selectedBrandId || 0,
          limit: 50,
          page: 1,
        });
        this.searchedProducts = res.data || [];
      } catch (e) { this.searchedProducts = []; }
    },
    async fetchPackages() {
      try {
        const res = await axios.get(`api/v1/repair_package?model_id=0`);
        this.packageList = res.data || [];
      } catch (e) { this.packageList = []; }
    },
    addOrderService(pkg) {
      const existing = this.newOrder.services.find(s => s.package_id === pkg.id);
      if (existing) {
        existing.count = (existing.count || 1) + 1;
        return;
      }
      const type = this.clientSaleType;
      const labor = type === 'optom' ? Number(pkg.labor_price_optom || 0) : Number(pkg.labor_price_chakana || 0);
      const redo = type === 'optom' ? Number(pkg.redo_price_optom || 0) : Number(pkg.redo_price_chakana || 0);
      const product_summa = (pkg.items || []).reduce((s, i) => {
        const ip = type === 'optom' ? Number(i.price_optom || 0) : Number(i.price_chakana || 0);
        return s + ip * (i.quantity || 1);
      }, 0);
      this.newOrder.services.push({
        package_id: pkg.id,
        name: pkg.name,
        count: 1,
        price: labor + redo,
        labor_price_chakana: Number(pkg.labor_price_chakana || 0),
        redo_price_chakana: Number(pkg.redo_price_chakana || 0),
        labor_price_optom: Number(pkg.labor_price_optom || 0),
        redo_price_optom: Number(pkg.redo_price_optom || 0),
        product_summa,
      });
      if (pkg.items && pkg.items.length > 0) {
        for (const item of pkg.items) {
          // Ba'zi paketlarda mahsulotsiz (product_id=NULL) bo'sh qator saqlanib
          // qolgan — shuni qo'shsak buyurtmada "Noma'lum / 0 / 0" bo'lib chiqadi.
          if (!item.product_id) continue;
          const ip = type === 'optom' ? Number(item.price_optom || 0) : Number(item.price_chakana || 0);
          this.newOrder.serviceProducts.push({
            product_id: item.product_id,
            name: item.product?.extra_name || item.product?.name || 'Mahsulot',
            count: item.quantity || 1,
            price: ip,
            price_chakana: Number(item.price_chakana || 0),
            price_optom: Number(item.price_optom || 0),
            from_service: pkg.id,
          });
        }
      }
    },
    decrementService(idx) {
      const srv = this.newOrder.services[idx];
      if (srv.count > 1) {
        srv.count--;
      } else {
        this.removeOrderService(idx);
      }
    },
    removeOrderService(idx) {
      const srv = this.newOrder.services[idx];
      this.newOrder.services.splice(idx, 1);
      this.newOrder.serviceProducts = this.newOrder.serviceProducts.filter(p => p.from_service !== srv.package_id);
    },
    isProductInCart(id) {
      return this.newOrder.products.some(p => p.product_id === id && !p.from_service);
    },
    isServiceInCart(id) {
      return this.newOrder.services.some(s => s.package_id === id);
    },
    getProductCount(id) {
      const p = this.newOrder.products.find(x => x.product_id === id && !x.from_service);
      return p ? p.count : 0;
    },
    getServiceCount(id) {
      const s = this.newOrder.services.find(x => x.package_id === id);
      return s ? s.count : 0;
    },
    decrementProductById(id) {
      const idx = this.newOrder.products.findIndex(x => x.product_id === id && !x.from_service);
      if (idx === -1) return;
      const p = this.newOrder.products[idx];
      if (p.count > 1) {
        p.count--;
      } else {
        this.newOrder.products.splice(idx, 1);
      }
    },
    decrementServiceById(id) {
      const idx = this.newOrder.services.findIndex(x => x.package_id === id);
      if (idx === -1) return;
      const s = this.newOrder.services[idx];
      if (s.count > 1) {
        s.count--;
      } else {
        this.removeOrderService(idx);
      }
    },
    async submitNewOrder() {
      if (!this.newOrder.kontragent_id) return alert('Mijozni tanlang!');
      if (this.newOrder.products.length === 0 && this.newOrder.services.length === 0) {
        return alert('Kamida bitta mahsulot yoki xizmat tanlang!');
      }
      this.creatingOrder = true;
      try {
        const payload = {
          kontragent_id: this.newOrder.kontragent_id,
          phone_number: this.newOrder.phone_number,
          address: this.newOrder.address,
          comment: this.newOrder.comment || 'Admin tomonidan yaratildi',
          lat: '', long: '',
          products: this.newOrder.products
            .filter(p => !p.from_service)
            .map(p => ({
              product_id: p.product_id,
              count: p.count,
              price: p.price,
              shtrix_kod: p.shtrix_kod || '',
            })),
          services: this.newOrder.services.flatMap(s => {
            const one = {
              package_id: s.package_id,
              name: s.name,
              count: s.count || 1,
              price: s.price,
              labor_price_chakana: s.labor_price_chakana,
              redo_price_chakana: s.redo_price_chakana,
              labor_price_optom: s.labor_price_optom,
              redo_price_optom: s.redo_price_optom,
              product_summa: s.product_summa,
            };
            return Array(s.count || 1).fill(0).map(() => ({ ...one }));
          }),
        };
        await axios.post('/api/v1/bron/makeOrder', payload);
        this.$emit('created');
        this.closeModal();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || 'Buyurtma yaratishda xato'));
      } finally {
        this.creatingOrder = false;
      }
    },
  },
};
</script>

<style scoped>
.folder-path {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
}
.folder-path a { color: #7c3aed; text-decoration: none; }
.folder-path a:hover { text-decoration: underline; }
.fp-sep { color: #94a3b8; }
.fp-active { color: #334155; }
.browse-card.folder-card {
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #fffbeb;
  border-color: #fde68a;
  user-select: none;
}
.browse-card.folder-card:hover { background: #fef3c7; }
.folder-icon { font-size: 26px; color: #f59e0b; }
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(15, 23, 42, 0.3);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.animate-pop { animation: pop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
@keyframes pop {
  0% { transform: scale(0.9); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

.order-modal {
  background: white;
  border-radius: 20px;
  width: 95vw;
  max-width: 1200px;
  height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  overflow: hidden;
}

.order-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.order-modal-header h3 { margin: 0; font-weight: 800; color: #a142f4; font-size: 20px; }
.header-info { display: flex; align-items: center; gap: 12px; }

.sale-type-badge {
  padding: 4px 14px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1px;
}
.sale-type-badge.chakana { background: #dbeafe; color: #2563eb; }
.sale-type-badge.optom { background: #fef3c7; color: #d97706; }

.btn-close-modal {
  background: #f1f5f9;
  border: none;
  font-size: 22px;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  color: #64748b;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-close-modal:hover { background: #fee2e2; color: #ef4444; }

.order-modal-body {
  display: flex;
  flex: 1;
  min-height: 0;
}

/* CHAP PANEL */
.panel-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #f1f5f9;
  min-width: 0;
}
.panel-section {
  padding: 14px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.browse-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 20px;
  min-height: 0;
}

/* Brend va Model chiplar */
.brand-chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding: 8px 20px;
  border-top: 1px solid #f1f5f9;
}
.brand-chips.type-chips {
  background: #faf8ff;
}
.brand-chips.model-chips {
  border-top: none;
  padding-top: 0;
  padding-bottom: 10px;
}
.chip-count {
  background: rgba(148, 163, 184, 0.15);
  color: inherit;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 800;
  margin-left: 2px;
}
.brand-chip.active .chip-count {
  background: rgba(255, 255, 255, 0.3);
}
.brand-chip.back-chip {
  background: white;
  color: #475569;
  border-color: #cbd5e1;
  font-weight: 700;
}
.brand-chip.back-chip:hover {
  background: #f1f5f9;
  color: #a142f4;
  border-color: #a142f4;
}
.brand-chip {
  background: #f8fafc;
  color: #475569;
  border: 1px solid #e2e8f0;
  padding: 5px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: 0.15s;
  white-space: nowrap;
}
.brand-chip:hover {
  border-color: #a142f4;
  color: #a142f4;
  background: white;
}
.brand-chip.active {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border-color: transparent;
  box-shadow: 0 2px 8px rgba(161, 66, 244, 0.3);
}
.model-chips .brand-chip.active {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}
.brand-chip-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  border-radius: 4px;
}
.all-icon-small {
  font-size: 14px;
  line-height: 1;
}

/* Paket turi filterlari */
.type-filter {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 10px;
  padding: 6px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  flex-shrink: 0;
}
.type-btn {
  background: white;
  color: #475569;
  border: 1px solid #e2e8f0;
  padding: 5px 12px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: 0.15s;
  white-space: nowrap;
}
.type-btn:hover {
  border-color: #a142f4;
  color: #a142f4;
}
.type-btn.active {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border-color: transparent;
  box-shadow: 0 2px 8px rgba(161, 66, 244, 0.3);
}
.type-count {
  background: rgba(255, 255, 255, 0.35);
  color: inherit;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 800;
}
.type-btn:not(.active) .type-count {
  background: #f1f5f9;
  color: #64748b;
}

.browse-grid {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;
  align-content: start;
}

.browse-card {
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 12px;
  cursor: pointer;
  transition: 0.15s;
  position: relative;
}
.browse-card:hover {
  border-color: #a142f4;
  background: #faf8ff;
  box-shadow: 0 2px 8px rgba(161,66,244,0.08);
}
.browse-card-added {
  border-color: #10b981 !important;
  background: #ecfdf5 !important;
}
.browse-card.pkg-card { border-left: 3px solid #a142f4; }

.bc-name {
  font-weight: 700;
  font-size: 13px;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bc-meta { margin-top: 2px; }
.bc-balance { font-size: 11px; color: #94a3b8; }

.bc-prices {
  display: flex;
  gap: 8px;
  margin-top: 6px;
}
.bc-price {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #64748b;
}
.bc-price.active {
  background: #ecfdf5;
  color: #059669;
}
.bc-materials {
  margin-top: 4px;
  font-size: 10px;
  color: #a142f4;
  font-weight: 700;
}
.bc-check {
  position: absolute;
  top: 8px; right: 8px;
  width: 22px; height: 22px;
  border-radius: 50%;
  background: #10b981;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}

.bc-count-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  min-width: 26px;
  height: 26px;
  padding: 0 8px;
  border-radius: 14px;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.4);
  animation: badge-pop 0.2s ease-out;
}

/* Qty controls - card ustida soni oshirish/kamaytirish */
.qty-controls {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  gap: 3px;
  background: linear-gradient(135deg, #10b981, #059669);
  padding: 2px 3px;
  border-radius: 16px;
  box-shadow: 0 3px 10px rgba(16, 185, 129, 0.4);
  animation: badge-pop 0.2s ease-out;
}
.pkg-card .qty-controls {
  background: linear-gradient(135deg, #a142f4, #8b2cf5);
  box-shadow: 0 3px 10px rgba(161, 66, 244, 0.4);
}
.qty-btn-small {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.25);
  color: white;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: 0.15s;
}
.qty-btn-small:hover {
  background: rgba(255, 255, 255, 0.45);
  transform: scale(1.1);
}
.qty-btn-small.minus:hover {
  background: #ef4444;
}
.qty-num {
  color: white;
  font-weight: 800;
  font-size: 12px;
  min-width: 16px;
  text-align: center;
}

@keyframes badge-pop {
  0% { transform: scale(0.5); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
.browse-empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 30px 0;
  color: #94a3b8;
  font-size: 13px;
}

/* O'NG PANEL */
.panel-right {
  width: 360px;
  min-width: 360px;
  display: flex;
  flex-direction: column;
  background: #fafbfc;
}
.cart-title {
  padding: 14px 20px;
  font-weight: 800;
  font-size: 15px;
  color: #1e293b;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.cart-count {
  background: #a142f4;
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 800;
}
.cart-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cbd5e1;
  font-size: 13px;
  padding: 20px;
  text-align: center;
}
.cart-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px 14px;
}

.cart-item {
  background: white;
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 6px;
  border: 1px solid #e2e8f0;
}
.cart-service {
  border-left: 3px solid #a142f4;
  background: #faf8ff;
}
.ci-top {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 6px;
}
.ci-name {
  font-weight: 700;
  font-size: 13px;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}
.ci-remove {
  background: none;
  border: none;
  color: #cbd5e1;
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
  padding: 0 0 0 8px;
}
.ci-remove:hover { color: #ef4444; }
.ci-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ci-badge {
  font-size: 10px;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 6px;
  background: #f5f0ff;
  color: #a142f4;
}
.ci-qty {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.ci-price {
  font-weight: 800;
  font-size: 14px;
  color: #1e293b;
}
.ci-material {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #94a3b8;
  padding: 3px 0 0 12px;
  border-top: 1px solid #f1f5f9;
  margin-top: 4px;
}
.qty-btn {
  width: 26px;
  height: 26px;
  border: none;
  background: none;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qty-btn:hover { color: #a142f4; }
.qty-val {
  font-weight: 800;
  min-width: 24px;
  text-align: center;
  font-size: 13px;
}

.cart-footer {
  padding: 14px 20px;
  border-top: 2px solid #e2e8f0;
  flex-shrink: 0;
}
.cart-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-weight: 800;
  font-size: 16px;
}
.total-value { color: #a142f4; }
.submit-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #a142f4, #7c3aed);
  color: white;
  font-weight: 800;
  font-size: 14px;
  cursor: pointer;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 14px rgba(161,66,244,0.3);
  transition: 0.2s;
}
.submit-btn:hover { box-shadow: 0 6px 20px rgba(161,66,244,0.4); }
.submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }

/* Form elements */
.form-group { margin-bottom: 10px; }
.form-group label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 3px;
  text-transform: uppercase;
}
.form-input {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 13px;
  outline: none;
}
.form-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161,66,244,0.1);
}
.row-2 { display: flex; gap: 10px; }
.row-2 > * { flex: 1; }

/* NAV BAR */
.nav-bar {
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
  background: #fafbfc;
}
.nav-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 20px;
  flex-wrap: wrap;
}
.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 700;
}
.breadcrumb-nav a {
  color: #a142f4;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-nav a:hover { text-decoration: underline; }
.bc-sep { color: #cbd5e1; margin: 0 2px; }
.bc-current { color: #475569; }

.nav-search {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 5px 12px;
  font-size: 12px;
  outline: none;
  width: 180px;
  flex-shrink: 0;
}
.nav-search:focus { border-color: #a142f4; }

.nav-tabs {
  display: flex;
  gap: 4px;
  margin-left: auto;
}
.nav-tab-btn {
  padding: 5px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  cursor: pointer;
  transition: 0.15s;
}
.nav-tab-btn.active {
  background: #a142f4;
  color: white;
  border-color: #a142f4;
}
.nav-tab-btn:hover:not(.active) { border-color: #a142f4; color: #a142f4; }

/* BRAND / MODEL GRID */
.brand-grid {
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
}
.brand-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 14px 8px;
}
.brand-img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  border-radius: 8px;
}
.all-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 8px;
  background: #f0f0ff;
  border-color: #c4b5fd;
}
.all-card:hover { background: #e8e5ff; }
.all-icon {
  font-size: 28px;
  color: #a142f4;
}

/* Mobil tab tugmalari — faqat kichik ekranda ko'rinadi (desktopda display:none) */
.mobile-panel-tabs {
  display: none;
}
.mpt-btn {
  flex: 1;
  padding: 12px 10px;
  border: none;
  background: white;
  color: #64748b;
  font-weight: 700;
  font-size: 14px;
  border-bottom: 3px solid transparent;
  cursor: pointer;
}
.mpt-btn.active {
  color: #a142f4;
  border-bottom-color: #a142f4;
}
.mpt-badge {
  background: #a142f4;
  color: white;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 800;
  margin-left: 4px;
}

@media (max-width: 900px) {
  /* Modal butun ekranni egallaydi, ichkarida tugma/inputlar sig'ib ketishi uchun */
  .order-modal {
    width: 100vw;
    max-width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }
  .mobile-panel-tabs {
    display: flex;
    border-bottom: 1px solid #f1f5f9;
    flex-shrink: 0;
  }
  .order-modal-body {
    flex-direction: column;
  }
  /* Ikki panel navbat bilan (tab orqali) to'liq balandlikni egallaydi —
     ikkalasi bir vaqtda 50/50 siqilib qolmasligi uchun */
  .panel-left,
  .panel-right {
    width: 100%;
    min-width: unset;
    flex: 1;
    min-height: 0;
    border-right: none;
  }
  .panel-left.mobile-hidden,
  .panel-right.mobile-hidden {
    display: none;
  }
}

/* Mijoz tanlash + qo'shish */
.client-select-row {
  display: flex;
  gap: 6px;
  align-items: stretch;
}
.client-picker {
  position: relative;
  flex: 1;
  min-width: 0;
}
.client-select-row .form-input {
  flex: 1;
  min-width: 0;
}
.client-results {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 220px;
  overflow-y: auto;
  padding: 4px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.15);
  z-index: 20;
}
.client-result {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 10px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: #1e293b;
  text-align: left;
  cursor: pointer;
}
.client-result:hover {
  background: #f1f5f9;
}
.client-result span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.client-result small {
  flex-shrink: 0;
  color: #64748b;
}
.client-no-results {
  padding: 12px 10px;
  color: #64748b;
  font-size: 13px;
  text-align: center;
}
.btn-add-client {
  flex-shrink: 0;
  width: 38px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #a142f4, #7c3aed);
  color: white;
  font-size: 20px;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
  transition: 0.2s;
  box-shadow: 0 2px 8px rgba(161, 66, 244, 0.3);
}
.btn-add-client:hover {
  box-shadow: 0 4px 14px rgba(161, 66, 244, 0.45);
}

/* Yangi mijoz modali */
.client-overlay {
  z-index: 1100;
}
.client-modal {
  background: white;
  border-radius: 20px;
  width: 94vw;
  max-width: 880px;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}
.client-modal-body {
  padding: 24px 28px;
  overflow-y: auto;
}
.client-cols {
  display: flex;
  gap: 30px;
}
.client-col {
  flex: 1;
  min-width: 0;
}
.client-col-divider {
  border-right: 1px solid #f1f2f6;
  padding-right: 30px;
}
.client-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  color: #2c3e50;
  font-weight: 700;
  font-size: 15px;
}
.client-section-header svg {
  color: #a142f4;
}
.cu-row {
  display: flex;
  gap: 14px;
}
.cu-row > .form-unit {
  flex: 1;
  min-width: 0;
}

/* Form units (Malumot/Kontragent/Form.vue dan nusxa) */
.client-modal .form-unit {
  margin-bottom: 18px;
}
.client-modal .form-unit label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #95a5a6;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.client-modal .form-unit input,
.client-modal .form-unit textarea {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 12px;
  padding: 12px 15px;
  color: #2c3e50;
  font-weight: 600;
  transition: 0.3s;
  font-size: 14px;
}
.client-modal .form-unit input:focus,
.client-modal .form-unit textarea:focus {
  background: white;
  border-color: #a142f4;
  outline: none;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.05);
}
.client-modal .form-unit textarea {
  resize: vertical;
}

/* Sotuv turi toggle */
.sale-type-toggle {
  display: flex;
  gap: 10px;
}
.sale-type-btn {
  flex: 1;
  padding: 10px 20px;
  border-radius: 12px;
  border: 1px solid #e0e6ed;
  background: #f8fafc;
  color: #7f8c8d;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
}
.sale-type-btn.active {
  background: #a142f4;
  color: white;
  border-color: #a142f4;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
}
.sale-type-btn:hover:not(.active) {
  border-color: #a142f4;
  color: #a142f4;
}

/* Mijoz turi toggle */
.client-type-toggle {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.client-type-btn {
  flex: 1;
  min-width: 110px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid #e0e6ed;
  background: #f8fafc;
  color: #7f8c8d;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: 0.25s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.client-type-btn.active {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border-color: #a142f4;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
}
.client-type-btn:hover:not(.active) {
  border-color: #a142f4;
  color: #a142f4;
}
.required-star {
  color: #e11d48;
  font-weight: 800;
  margin-left: 2px;
}

.client-modal-footer {
  display: flex;
  gap: 10px;
  padding: 16px 28px;
  border-top: 1px solid #f1f5f9;
  flex-shrink: 0;
}
.client-modal-footer .submit-btn {
  flex: 1;
}
.client-cancel-btn {
  padding: 14px 24px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: white;
  color: #64748b;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: 0.15s;
}
.client-cancel-btn:hover {
  background: #f1f5f9;
  color: #ef4444;
  border-color: #fecaca;
}

@media (max-width: 768px) {
  .client-cols {
    flex-direction: column;
    gap: 0;
  }
  .client-col-divider {
    border-right: none;
    border-bottom: 1px solid #f1f2f6;
    padding-right: 0;
    margin-bottom: 20px;
    padding-bottom: 10px;
  }
}
</style>
